import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import page components
import HomePage from '../pages/home';

import AuthPage from '../pages/auth';
import MarketplacePage from '../pages/marketplace';
import VerifierPage from '../pages/verifier';
import NotFoundPage from '../pages/notFound';

// Import marketplace components
import MarketplaceListing from '../components/marketplace/MarketplaceListing';
import CreateProject from '../components/marketplace/CreateProject';
import ProjectDetails from '../components/marketplace/ProjectDetails';
import PurchaseCredits from '../components/marketplace/PurchaseCredits';
import MyProjects from '../components/marketplace/MyProjects';

// Import unified components
import UnifiedDashboard from '../components/dashboard/UnifiedDashboard';
import UnifiedVerification from '../components/verification/UnifiedVerification';

// Import profile components
import UserProfile from '../components/profile/UserProfile';
import AccountSettings from '../components/profile/AccountSettings';

// Import existing specialized components (for backward compatibility)
import AdminDashboard from '../components/admin/AdminDashboard';
import ApplicationReview from '../components/admin/ApplicationReview';
import EscrowSystem from '../components/payments/EscrowSystem';
import VerifierDirectory from '../components/verifiers/VerifierDirectory';

// Import verification components
import VerificationRequestManager from '../components/verification/VerificationRequestManager';
import VerificationProposalWorkspace from '../components/verification/VerificationProposalWorkspace';
import ProjectVerificationDashboard from '../components/verification/ProjectVerificationDashboard';
import MultiVerifierSystem from '../components/verification/MultiVerifierSystem';

// Import verifier components
import VerifierRegistration from '../components/verifier/VerifierRegistration';
import VerifierDashboard from '../components/verifier/VerifierDashboard';
import VerifierMarketplace from '../components/verifier/VerifierMarketplace';
import VerifierProfile from '../components/verifier/VerifierProfile';
import VerificationProjects from '../components/verifier/VerificationProjects';
import VerificationWorkspace from '../components/verifier/VerificationWorkspace';

// Import API test component
import ApiTestPage from '../components/ApiTestPage';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Main Pages */}
      <Route path="/" element={<HomePage />} />
     
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/marketplace" element={<MarketplacePage />} />
      <Route path="/verifier" element={<VerifierPage />} />

      {/* API Test Page */}
      <Route path="/api-test" element={<ApiTestPage />} />

      {/* Unified Routes */}
      <Route path="/dashboard/*" element={<UnifiedDashboard />} />
      <Route path="/verify/*" element={<UnifiedVerification />} />

      {/* Marketplace Routes */}
      <Route path="/marketplace/listing" element={<MarketplaceListing />} />
      <Route path="/marketplace/create" element={<CreateProject />} />
      <Route path="/marketplace/project/:id" element={<ProjectDetails />} />
      <Route path="/marketplace/purchase/:id" element={<PurchaseCredits />} />
      <Route path="/marketplace/my-projects" element={<MyProjects />} />

      {/* Admin Routes */}
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/applications" element={<ApplicationReview />} />
      <Route path="/admin/analytics" element={<AdminDashboard />} />
      <Route path="/admin/users" element={<AdminDashboard />} />
      <Route path="/admin/settings" element={<AdminDashboard />} />

      {/* Verifier Registration & Profile */}
      <Route path="/verifier/register" element={<VerifierRegistration />} />
      <Route path="/verifier/profile" element={<VerifierProfile />} />
      <Route path="/verifier/dashboard" element={<VerifierDashboard />} />

      {/* Verifier Directory */}
      <Route path="/verifiers" element={<VerifierDirectory />} />

      {/* Verification Routes - Individual components for direct access */}
      <Route path="/verification/requests" element={<VerificationRequestManager />} />
      <Route path="/verification/workspace" element={<VerificationProposalWorkspace />} />
      <Route path="/verification/dashboard" element={<ProjectVerificationDashboard />} />
      <Route path="/verification/multi-verifier" element={<MultiVerifierSystem />} />
      <Route path="/verification/marketplace" element={<VerifierMarketplace />} />
      <Route path="/verification/projects" element={<VerificationProjects />} />
      <Route path="/verification/verifier-workspace" element={<VerificationWorkspace />} />

      {/* Payment Routes */}
      <Route path="/payments/escrow" element={<EscrowSystem />} />

      {/* Account Routes */}
      <Route path="/account/profile" element={<UserProfile />} />
      <Route path="/account/settings" element={<AccountSettings />} />

      {/* Legacy Routes - Redirect to unified components */}
      <Route path="/marketplace/index" element={<MarketplacePage />} />
      <Route path="/home" element={<HomePage />} />

      {/* 404 Page */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
